import React from "react";
import { Table } from "antd";
import { useAppStatisticModel } from "../appStatisticModel";
import { ColumnsType } from "antd/es/table";
import { IMdAppStatistic } from "../AppStatisticTypes";
import moment from "moment";

const columns: ColumnsType<IMdAppStatistic> = [

    // {
    //     align: "center",
    //     title: '所属机构',
    //     width: 200,
    //     dataIndex: 'branch',
    // },
    {
        align: "center",
        title: '应用名称',
        // width: 320,
        dataIndex: 'appName',
    },
    {
        align: "center",
        title: '用户数量',
        dataIndex: 'total',
    },
    {
        align: "center",
        title: '使用次数',
        // width: 120,
        dataIndex: 'userNumber',
    },
    {
        align: "center",
        title: '使用率',
        // width: 120,
        dataIndex: 'usage',
        render: (v) => v * 100 + '%'
    },

    {
        align: "center",
        title: '创建时间',
        // width: 120,
        dataIndex: 'createTime',
        render: (dateArray) => dateArray ? moment([
            dateArray[0],
            dateArray[1] - 1, // 将月份减1，使5→4（代表5月）
            dateArray[2],
            dateArray[3],
            dateArray[4],
            dateArray[5]
        ]).format("YYYY-MM-DD HH:mm:ss") : ''
    },
];

export function DataTable() {
    const {
        dataSource, pgCfg,
        loadData
    } = useAppStatisticModel();


    return (
        <Table
            style={{ cursor: "pointer" }}
            // rowSelection={{
            //     type: "radio",
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IMdAppStatistic[]) => {
            //         setSelectedRowKeys(selectedRowKeys);
            //     },
            //     selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
        // onRow={record => {
        //     return {
        //         onClick: event => {
        //             if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
        //                 setSelectedRowKeys([]);
        //             } else {
        //                 setSelectedRowKeys([record.key]);
        //             }
        //         },
        //     };
        // }}
        />
    )
}
